<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page edit">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-10 medium-offset-1 large-6 large-offset-0 cell">
          <bouton href="dashboard" class-bt="return">Retour au carnet de bord</bouton>
          <title-page attrpage="La Team de soignants" baseline="">Créez et gérez la team de soignants de {{ childName }}</title-page>
          <p>Cette page vous permet de gérer la liaison des comptes Globulo Quest des soignants à celui de {{ childName }}. Ils pourront ainsi l’aider durant son chemin vers la guérison.</p>

          </br>

          <hr>
          <template v-if="caregivers.length === 0">
            <p>{{ childName }} <strong>n’a aucun soignant dans sa team</strong> actuellement. </p>

            <p>Vous pouvez suggérer à un soignant de se créer un compte Globulo Quest relié à celui de {{ childName }} en renseignant son email ici. Une notification lui sera envoyée pour qu’il puisse s’inscrire et suivre le profil de {{ childName }}.</p>
          </template>

          <div class="formulaire soignant">
            <form ref="form">
              <input type="email" name="email" id="email" v-model="email" required />
              <input class="button btnPush" name="submit" type="submit" value="Envoyer une demande" @click="send"/>
            </form>
          </div>
        </div>

        <template v-if="caregivers.length !== 0">
          <div class="small-12 medium-10 large-6 medium-offset-1 large-6 large-offset-0 cell">

            <div class="list-soignants">
              <span class="label">Accès au rapport d’humeur</span>

              <item-caregiver v-for="caregiver in caregivers" :user="caregiver" />
              <item-caregiver v-for="caregiver in invitedCaregivers" :user="caregiver" :invited="true"/>

            </div>

          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import ItemCaregiver from '@/components/ItemCaregiver'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: { TitlePage, Bouton, ItemCaregiver },
    data() {
      return {
        email: ''
      }
    },
    computed: {
      ...mapGetters(['childName']),
      caregivers() {
        return this.$store.state.subaccounts.caregivers
      },
      invitedCaregivers() {
        return this.$store.state.subaccounts.invitedCaregivers || []
      }
    },
    methods: {
      ...mapActions(['sendInvitation', 'addNotice']),
      async send (e) {
        e.preventDefault();

        try {
          this.sendInvitation({ identifier: this.email, role: 'caregiver' })
          this.addNotice({ message: `L'invitation a été envoyée avec succès.` })
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log(ex)
        }
      }
    }
  }
</script>
